<template>
  <li class="asc-legend-list-item">
    <div
      :class="[
        'asc-legend-list-item--content',
        isSelected ? 'asc-legend-list-item--disabled' : null,
      ]"
      @click="handleItemClick"
    >
      <div class="asc-legend-list-item--flex">
        <div
          class="asc-legend-list-item--icon"
          :style="{
            'background-color': styleColor,
            height: '12px',
            width: '12px',
            'border-radius': borderRadius,
            border: border,
          }"
        ></div>
        <div
          :class="[
            'asc-legend-list-item--text',
            filter ? 'asc-legend-list-item--text-hover' : '',
          ]"
        >
          {{ text }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscLegendListItem',

  props: {
    styleColor: {
      type: String,
      default: variables.primaryblack,
    },
    borderRadius: {
      type: String,
      default: '0%',
    },
    border: {
      type: String,
      default: 'none',
    },
    text: {
      type: String,
      default: 'N/A',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Boolean,
      default: false,
    },
    onItemClick: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    isIcon() {
      return this.icon !== ''
    },
  },

  methods: {
    handleItemClick() {
      if (this.onItemClick) {
        this.onItemClick(this.text)
      }
    },
  },
}
</script>

<style lang="scss">
li.asc-legend-list-item {
  margin-bottom: 5px;

  .asc-legend-list-item--content {
    display: inline-block;

    .asc-legend-list-item--flex {
      display: flex;

      .asc-legend-list-item--text {
        color: $gray-1000;
        font-size: 13px;
        letter-spacing: 0;
        border-bottom: 2px solid $primary-white;
      }

      .asc-legend-list-item--text-hover:hover {
        cursor: pointer;
        border-bottom: 2px solid $accent-600;
        color: $accent-700;
      }

      .asc-legend-list-item--icon {
        content: '';
        margin-right: 5.85px;
        margin-bottom: 2px;
        height: 4px;
        width: 3.9px;
        margin-top: 2px;
      }

      i {
        margin-right: 5.85px;
        margin-bottom: 2px;
      }
    }
  }
}

.asc-legend-list-item {
  .asc-legend-list-item--disabled {
    .asc-legend-list-item--icon {
      background-color: $gray-300 !important;
    }

    .asc-legend-list-item--text {
      color: $gray-300 !important;
    }
  }
}
</style>
